import { Box } from '@mui/material';
import { ReactNode } from 'react';

const MIN_HEIGHT = 120;

interface CenteredStateProps {
  children: ReactNode;
  role?: React.AriaRole;
  testId?: string;
  minHeight?: number;
}

function CenteredState({ children, role, testId, minHeight = MIN_HEIGHT }: CenteredStateProps) {
  return (
    <Box
      role={role}
      test-id={testId}
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        minHeight,
        p: 2,
      }}
    >
      {children}
    </Box>
  );
}

export default CenteredState;
